var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'anchor-wrapper': true,
    'show': _vm.scrollUpFlag,
  },attrs:{"id":"anchor-container"}},[_c('div',{class:{
    'anchor': true,
    'active': _vm.partNumber===1,
    }},[_vm._v("\n    救命救錢的幾秒鐘\n  ")]),_c('a',{attrs:{"href":"./fault/"},on:{"click":function($event){return _vm.sendGA('然後呢point2')}}},[_c('div',{class:{
      'anchor': true,
      'active': _vm.partNumber===2,
      }},[_vm._v("\n        斷層旁住滿人\n    ")])]),_c('a',{attrs:{"href":"./response/"},on:{"click":function($event){return _vm.sendGA('然後呢point3')}}},[_c('div',{class:{
      'anchor': true,
      'active': _vm.partNumber===3,
      }},[_vm._v("\n        救災時忙表單\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }